import $ from 'jquery';
import Mustache from 'mustache';

$(function() {

    var list = $('[data-products-list]');
    if(!list.length) return;


    var items = list.find('[data-products-list-items]');
    var moreEl = list.find('[data-products-list-more]');
    var itemTemplate = $('#products-list-item-template').html();
    var placeholder = list.find('[data-products-list-placeholder]');


    function loadMore( more ) {
        var data = {};
        var hash = [];
        data.action = 'load_more_products';

        data.offset = 0;
        data.num = moreEl.data('products-list-more');
        if(more) {
            if(typeof more == "number") {
                data.num = more;
            }
            data.offset = items.children().length;
        }

        if(!hash.length && placeholder.length) {
            placeholder.show();
            items.hide().html('');
            return;
        }

        list.addClass('loading');
        $.get(window.App.ajaxurl,data,function(r) {
            placeholder.hide();
            items.show();

            if(!more) {
                items.html('');
            }
            if(r.items && r.items.length) {
                r.items.forEach( item => {
                    var html = Mustache.render(itemTemplate,item);
                    items.append(html);
                } );
            }
            if(r.hasMore) {
                moreEl.css('display','flex');
            } else {
                moreEl.hide();
            }
            list.removeClass('loading');
            list.initImages();
        });
    }

    moreEl.find('a').on('click',loadMore);



    if(items.children().length) {
        var first = items.children().first();
        var n = Math.round( items.outerWidth() / first.outerWidth() );
        var num = n * 3;
        moreEl.attr('data-products-list-more',num);
        if(items.children().length < num) {
            loadMore(num - items.children().length);
        } else if(items.children().length > num) {
            //remove items
            items.children().slice(num).remove();
        }
    }


});
